import { useCallback, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useOnClickOutside } from "hooks/ClickOutside";
import "./modal.scss";

interface IProps {
  isOpen: boolean;
  text: string;
  onClose: Function;
  top: number;
  left: number;
  children: React.ReactNode;
  offset?: {
    top: number;
    left: number;
  };
  width?: string;
}

const modalElement = document.getElementById("tooltip-root");

const ToolTipPortal = ({
  text,
  isOpen,
  top,
  left,
  onClose,
  children,
  offset = { top: 0, left: 0 },
  width
}: IProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleEscape = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleEscape, false);
    }
    return () => {
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [handleEscape, isOpen]);

  useOnClickOutside(ref, onClose);

  if (modalElement != null)
    return createPortal(
      isOpen ? (
        // The Modal
        <div
          ref={ref}
          className="g-modal-tooltip"
          style={{ top: top + offset.top, left: left + offset.left, width: width }}
        >
          <div className="tooltip-modal">
            <div className="modal-container">
              <span className="modal-title">{text}</span>
              <div className="tooltip-modal-content">{children}</div>
            </div>
          </div>
        </div>
      ) : null,
      modalElement
    );
  else {
    console.error("Tooltip root element should be defined in HTML template!");
    return null;
  }
};

export default ToolTipPortal;
